var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('option',{attrs:{"disabled":_vm.disabled},domProps:{"value":_vm.value,"selected":_vm.selected}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }